export const hasPermission = (permissions, code) =>
  Array.isArray(permissions) && permissions.includes(code);

export const hasAnyPermission = (permissions, codes) =>
  Array.isArray(codes) && codes.some((code) => hasPermission(permissions, code));
